import { GoalFormParam } from "web_myplann/Goals/Types/GoalFormParam";
import { InspirationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { parseEnumValue } from "web_myplann/Shared/Utils/parseEnumValue";

export const mapParamsToInspirationType = (
	params: URLSearchParams,
): InspirationTypeEnum | undefined =>
	parseEnumValue(
		InspirationTypeEnum,
		params.get(GoalFormParam.InspirationType),
	);
